import { useTranslation } from 'react-i18next'
import { Box, Chip, Typography } from '@mui/material'
import { UserLogged } from '@/state/auth/models'

type Props = {
  loggedUser: UserLogged
}

const HeaderProfileDetails = ({ loggedUser }: Props) => {
  const { t } = useTranslation()

  const getRoleName = (roleId: number) => {
    switch (roleId) {
      case 1:
        return 'roleType.SUPER_ADMIN'

      case 2:
        return 'roleType.AGENT'

      case 3:
        return 'roleType.MANAGER'

      default:
        return '-'
    }
  }

  const getRoleColor = (roleId: number) => {
    switch (roleId) {
      case 1:
        return 'green'

      case 2:
        return 'orange-dark'

      case 3:
        return 'blue'

      default:
        return '-'
    }
  }

  return (
    <Box display="flex" justifyContent="space-between" pb={2}>
      <Typography variant="h6">{t('profile.details')}</Typography>
      <Chip
        sx={{ minWidth: 100 }}
        variant="outlined"
        size="medium"
        label={t(getRoleName(loggedUser.role))}
        className={getRoleColor(loggedUser.role)}
      />
    </Box>
  )
}

export default HeaderProfileDetails
